/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { viewStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsView";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

viewStyles.noPaymentsWrapper = {};

viewStyles.mainContainer = {
    gap: 60,
};

viewStyles.headerLeftColumnGridItem = {
    width: [10, 10, 6, 6, 6],
};

viewStyles.mainLeftColumnGridItem = {
    width: 12,
    css: css`
        position: relative;
        &:after {
            content: " ";
            border-bottom: 1px solid ${getColor("common.ui12")};
            position: absolute;
            bottom: 0;
            right: 30px;
            left: 30px;
        }
    `,
};

viewStyles.mainRightColumnGridItem = {
    width: 12,
};
